<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-dialog
        v-model="dialogCreate"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogCreate"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Objednat jednorázový produkt</h2>
          </v-card-title>
          <v-card-text class="pt-0 pb-2">
            <v-form ref="createForm">
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <productsearch label="Vyhledat produkt"></productsearch>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    class="mx-2"
                    label="Zadejte slevu na 1 ks"
                    :suffix="' Kč '"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <p>Cena za 1 ks po slevě: <strong>100 Kč</strong></p>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="create" :loading="sending">Objednat</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogCreate=false" v-if="!sending">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-flex grow>
                <h3>Přehled jednorázových objednávek</h3>
              </v-flex>
              <v-flex shrink>
                <v-btn color="primary" small :href="api_url_admin+'export/jednorazove-nakupy/xlsx?'+export_query" target="_blank" class="ma-0" depressed>Exportovat</v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3">
              <v-flex xs12 sm3 md2>
                <v-text-field
                  label="Hledat objednávku"
                  class="mx-2"
                  v-model="search"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm5 md3>
                <osobasearch label="Osoba" v-model="osoba" class="mx-2" :all="true"></osobasearch>
              </v-flex>
              <v-flex xs12 sm4 md3>
                <stavobjednavkyselect label="Stav objednávky" v-model="stav"></stavobjednavkyselect>
              </v-flex>
              <v-spacer></v-spacer>
            </v-layout>
            <!--<v-layout row wrap>
              <v-flex xs12 sm4>
                <v-btn color="blue darken-3" @click="createClick" class="ma-0 mb-3" outline>
                  <v-icon class="mr-2">add</v-icon>
                  Objednat jednorázový produkt
                </v-btn>
              </v-flex>
            </v-layout>-->
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.datum | formatDate }}<div v-if="props.item.prenesena_dan" class="red--text">Přenesená daňová povinnost</div></td>
                  <td class="text-xs-right">{{ props.item.variabilni_symbol }}</td>
                  <td class="text-xs-right">{{ props.item.pocet_produktu }}</td>
                  <td class="text-xs-right">{{ props.item.castka_celkem | formatMoney }} {{props.item.mena.zkratka}}</td>
                  <td>
                    <router-link :to="{ path: '/klienti/' + props.item.osoba.id }" target="_blank">
                      {{ props.item.osoba.nazev_osoby }}
                    </router-link>
                  </td>
                  <td>
                    {{ props.item.stav_objednavky.nazev }}
                  </td>
                  <td>
                    <router-link :to="{ path: '/spolupracovnici/' + props.item.poradce.id }" target="_blank" v-if="props.item.poradce != null">
                      {{ props.item.poradce.nazev_osoby }}
                    </router-link>
                  </td>
                  <td class="text-center">
                    <router-link :to="{ path: '/objednavky-jednorazove/' + props.item.id }">
                      <v-btn color="primary" class="elevation-0">
                      <v-icon small class="mr-2">remove_red_eye</v-icon> Detail</v-btn>
                    </router-link>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      dialogCreate: false,
      headers: [
        { text: 'Datum', value: 'datum' },
        { text: 'Číslo objednávky (VS)', value: 'variabilni_symbol', align: "right" },
        { text: 'Počet produktů', value: 'pocet_produktu', align: "right" },
        { text: 'Celková cena', value: 'castka_celkem', align: "right" },
        { text: 'Klient', value: 'osoba' },
        { text: 'Stav', value: 'stav_objednavky', sortable: false },
        { text: 'Poradce', value: 'poradce', sortable: false },
        { text: 'Zobrazit', value: null, sortable: false, align: 'center' }
      ],
      items: [],
      loadingTable: true,
      search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "datum",
        totalItems: 0
      },
      osoba: null,
      stav: null,
      export_query: ""
    }
  },
  computed: {
    api_url_admin () {
      return window.api.$api_url;
    }
  },
  watch: {
    search () {
      this.queryList();
      this.makeExportQuery();
    },
    osoba () {
      this.load();
      this.makeExportQuery();
    },
    stav () {
      this.load();
      this.makeExportQuery();
    },
    pagination () {
      this.load();
    }
  },
  mounted: function() {
    this.load();
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("prehledy/jednorazove-nakupy/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        osoba: this.osoba,
        stav: this.stav
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    createClick () {
      //this.newItem = window.th.copy(this.dialogInit);
      this.dialogCreate = true;
    },
    makeExportQuery () {
      this.export_query = [
        this.search != null && this.search.length > 0 ? "s=" + this.search : null,
        this.osoba != null ? "o=" + this.osoba : null,
        this.stav != null ? "st=" + this.stav : null
      ].filter((e) => { return e != null }).join("&");
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/KlientiSpolupracovnici/ObjednavkyJednorazovychProduktu.vue